<template lang="html">
  <div>
    <div class="formulario-wrapper row-center ais" :how="where">

      <h3 class="title -ghost">{{$t('formulario.vive_experiencia')}}</h3>

      <div class="contenedor-titulo">
        <h2 class="title -xs">{{(where == 'enoturismo') ? $t('formulario.bodega')  : $t('formulario.almazara')}}</h2>
      </div>

      <div class="contenedor-formulario">

      <div class="contenedor-textos">

        <p>{{$t('formulario.concertar_visita')}}</p>

        <p class="-email -white"><a href="mailto:info@aldonzagourmet.com">info@aldonzagourmet.com</a></p>

        <p class="-telefono -white"><span>{{$t('banner_newsletter.telefono')}}</span> <span><a
              href="tel:+0034967376005">(+34) 967 21 77 11</a></span> <span class="line">-</span> <span><a
              href="tel:+0034660634959">(+34) 660 634 959</a></span></p>

        <p class="-calendario">{{$t('formulario.lunes_domingo')}}</p>

        <p class="-horario">{{$t('formulario.horario')}}</p>

      </div>

      <form id="formExperiencia" @submit.prevent="validateBeforeSubmit">



          <div class="contenedor-input row-start">
            <label for="">{{$t('formulario.nombre_apellidos')}}*</label>
            <input type="text" class="input-text" v-validate="'required'" name="nombre"
              :placeholder="$t('formulario.nombre_apellidos')+'*'" />
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
          </div>


          <div class="contenedor-input row-start">
            <label for="">{{$t('formulario.telefono')}}*</label>
            <input type="text" class="input-text" v-validate="'required|length:9'" name="telefono"
              :placeholder="$t('formulario.telefono')+'*'" />
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono') }}</span>
          </div>

          <div class="contenedor-input row-start">
            <label for="">{{$t('formulario.email')}}*</label>
            <input type="text" class="input-text" v-validate="'required|email'" name="email"
              :placeholder="$t('formulario.email')+'*'" />
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
          </div>

          <div class="contenedor-input row-start">
            <label for="">{{$t('formulario.mensaje')}}</label>
            <textarea :placeholder="$t('formulario.introduce_mensaje')" name="mensaje"></textarea>
          </div>

          <div class="bottom-form row-between" :enviado="enviado">

            <div class="checks">

              <div class="contenedor-check">
                <input type="checkbox" id="politica-contacto" v-validate="'required'" name="politica">
                <label for="politica-contacto">{{$t('formulario.he_leido')}} <router-link
                    :to="$t('enlaces.politica_proteccion')">{{$t('formulario.y_acepto')}}*</router-link></label>
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica')
                  }}</span>
              </div>

              <div class="contenedor-check -newsletter">
                <input type="checkbox" id="suscripcion-contacto" name="newsletter">
                <label for="suscripcion-contacto">{{$t('formulario.texto_newsletter')}}</label>
              </div>

            </div>

            <div class="contenedor-boton">
              <button class="btn" :loading="loading"
                :enviado="enviado"><span>{{$t('formulario.enviar')}}</span></button>
            </div>

            <div class="gracias row-center">{{$t('formulario.recibido')}}</div>

          </div>


          <input type="hidden" name="tipo_contacto" :value="'aldonza-experiencia'">
          <input type="hidden" name="lang" :value="lang">

          
          
        </form>
        
        
      </div>
      
      <popup-condiciones></popup-condiciones>

    </div>


  </div>

</template>

<script lang="js">


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import { mapGetters, mapActions } from 'vuex'

  import popupCondiciones from '@/components/view-parts/contacto/popup-contacto';



  export default {
    name: 'formulario-experiencias',
    props: ['where'],
    data() {
      return {
        clicked: false,
        loading: false,
        enviado: false,
        showPopup: false,
        popupAceptado: false
      }
    },
    components: {
      'popup-condiciones': popupCondiciones
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage'
      })
    },
    methods: {
      ...mapActions(['sendContacto']),
      validateBeforeSubmit: function () {

        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            this.loading = true;
            this.sendContacto($("#formExperiencia").serialize())
              .then(result => {
                if (result) {
                  this.enviado = true;
                  $("#formExperiencia")[0].reset();
                }
                this.loading = false;
              }).catch(e => {
                this.loading = false;
              });

          }
        });
      },
      aceptoPopup: function () {
        this.popupAceptado = true;
        this.showPopup = false;
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/colors.scss";

  .formulario-wrapper {

    background: $plum-90;
    position: relative;
    transform: translateY(200px);
    opacity: 0;
    padding: 0 30px;
    transition: 1s;


    &[how=enoturismo] {
      background: $mud-brown-90;
    }

    .title.-ghost {
      position: absolute;
      left: 0;
      top: -44px;
      transform: translateY(-100px);
      opacity: 0;
      transition: 1s;
    }

  }

  .contenedor-titulo {
    width: 100%;
    display: inline-block;
    text-align: center;
    padding: 45px 0;
    overflow: hidden;

    .title {
      text-align: center;
      padding-bottom: 10px;
      transform: translateY(-100px);
      opacity: 0;
      transition: 1s;
      transition-delay: .5s;

      &::before {
        display: inline-block;
        left: 50%;
        margin-left: -25px;
      }
    }

  }

  .contenedor-formulario{
    width: 50%;
  }

  form {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;

    .contenedor-input,
    .contenedor-check,
    .contenedor-boton .btn {
      transform: translateY(400px);
      opacity: 0;
      transition: 1s;
    }

    @for $i from 1 through 10 {
      .contenedor-input:nth-child(#{$i}) {
        transition-delay: #{$i / 10 + .7}s;
      }

      .contenedor-check:nth-child(#{$i}) {
        transition-delay: #{$i / 10 + 1.1}s;
      }
    }

    .contenedor-boton .btn {
      transition-delay: 1.5s;
    }

    .contenedor-boton .btn[enviado=true] {
      opacity: 0 !important;
      transition-delay: 0s;
    }


  }

  .contenedor-textos {
    width: 100%;
    padding-left: 0px;
    margin-bottom: 30px;

    p {
      transition: 1s;
      transform: translateY(400px);
      opacity: 0;
    }

    @for $i from 1 through 10 {
      p:nth-child(#{$i}) {
        transition-delay: #{$i / 10 + .7}s;
      }
    }

  }

  .bottom-form {

    position: relative;
    padding-bottom: 45px;

    .checks {
      width: calc(100% - 180px);
      transition: .5s;
    }

    &[enviado=true] .checks {
      transform: translateX(-200px);
      opacity: 0;
    }

    .contenedor-boton {
      width: auto;
      min-width: 180px;
      margin-top: 25px;
      padding-bottom: 0;
    }

    &[enviado=true] .btn {
      opacity: 0;
      transform: translateX(150px);
    }

    .gracias {
      font-size: 12px;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      pointer-events: none;
      opacity: 0;
      transition: .5s;
      width: 100%;
      transform: translateY(100%);
      padding-bottom: 45px;
    }

    &[enviado=true] .gracias {
      opacity: 1;
      transform: translateY(0%);
    }
  }

  .launched .formulario-wrapper {
    transform: translateY(-100px);
    opacity: 1;

    .title.-ghost {
      opacity: .5;
      transform: translate(0);
    }

    .contenedor-titulo>.title {
      opacity: 1;
      transform: translate(0);
    }

    .contenedor-input,
    .contenedor-check,
    .contenedor-boton .btn,
    .contenedor-textos p {
      transform: translate(0);
      opacity: 1;
    }

  }

  .showpopup {
    margin-bottom: 20px;
    font-size: 12px;
    text-decoration: underline;
    color: white;
    cursor: pointer;
    opacity: 0;
    transform: translateY(200px);
    transition-duration: 1s;

    &[error="1"] {
      color: #d4de3f;
      transition-delay: 0s;
      transition-duration: 0s;
    }
  }

  .launched .showpopup {
    opacity: 1;
    transform: translateY(0);
  }

  @media screen and (max-width:830px){
    .contenedor-formulario{
      width: 100%;
    }
  }


  @media screen and (max-width: 769px) {
    .formulario-wrapper {

      padding: 0 25px;

      padding-bottom: 50px;

      .title.-ghost {
        left: 25px;
      }

      form {
        width: 100%;
      }

      .contenedor-textos {
        width: 100%;
        padding-left: 0;
      }

    }
  }

  @media screen and (max-width: 769px) {
    .formulario-wrapper {

      .title.-ghost {
        display: none;
      }

      .contenedor-titulo {
        padding: 25px 0;
      }

      form {
        width: 100%;
      }

      .contenedor-textos {
        width: 100%;
        padding-left: 0;
      }


      .bottom-form .contenedor-boton {
        width: 100%;
        margin-top: 20px;
      }

      .bottom-form .checks {
        width: 100%;
      }

      .bottom-form {
        padding-bottom: 25px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/experiencias/formulario-experiencias.vue